import { defineStore } from "pinia";
import {
  login as userLogin,
  logout as userLogout,
  getUserInfo,
  LoginData,
  getRouters,
  getLoginProject,
} from "@/api/user";
import { setToken, clearToken } from "@/utils/auth";
import computedRouter from "@/utils/route";
import { removeRouteListener } from "@/utils/route-listener";
import { UserState } from "./types";

const useUserStore = defineStore("user", {
  state: (): UserState => ({
    admin: undefined,
    area: undefined,
    areaCode: undefined,
    areaName: undefined,
    avatar: undefined,
    barackUserType: undefined,
    barrackId: undefined,
    barrackName: undefined,
    createBy: undefined,
    createTime: undefined,
    delFlag: undefined,
    deptId: undefined,
    email: undefined,
    loginBarrackId: undefined,
    loginDate: undefined,
    loginIp: undefined,
    loginSchoolId: undefined,
    loginUserId: undefined,
    loginUserName: undefined,
    nickName: undefined,
    params: undefined,
    phonenumber: undefined,
    postIds: undefined,
    remark: undefined,
    roleIds: undefined,
    roles: undefined,
    project: undefined,
    permissions: undefined,
    userId: undefined,
    userName: undefined,
    userType: undefined,
  }),
  persist: {
    enabled: true,
  },
  getters: {
    userInfo(state: UserState): UserState {
      return { ...state };
    },
  },

  actions: {
    // switchRoles() {
    //   return new Promise((resolve) => {
    //     this.role = this.role === "user" ? "admin" : "user";
    //     resolve(this.role);
    //   });
    // },
    // Set user's information
    setInfo(partial: Partial<UserState>) {
      this.$patch(partial);
    },
    setLoginBarrackId(perload: string) {
      this.$patch({ loginBarrackId: perload });
    },
    setBarrackName(perload: string) {
      this.$patch({ barrackName: perload });
    },
    async checkUserInfo() {
      if (!this.permissions) {
        await this.info();
        await this.getBarrackId();
      }
    },
    // Reset user's information
    resetInfo() {
      this.$reset();
    },

    // Get user's information
    async info() {
      const res: any = await getUserInfo();
      if (res.code == 200) {
        const info = res.user;
        info.roles = res.roles;
        info.project = res.projectList;
        info.permissions = res.permissions;
        this.setInfo(info);
      } else {
        this.logout();
      }
    },
    async getBarrackId() {
      const res: any = await getLoginProject();
      const id = res.project ? res.project.id : null;
      const name = res.project ? res.project.barrackName : "";
      this.setLoginBarrackId(id);
      this.setBarrackName(name);
    },

    // Login
    async login(loginForm: LoginData) {
      try {
        const data =<any> {
          password: btoa(loginForm.password),//密码验证用base64加密
          code: loginForm.code,
          phonenumber: loginForm.phonenumber,
          uuid: loginForm.uuid
        }
        const res: any = await userLogin(data);
        if (res.code == 200) {
          // setToken(res.token);
          setToken(res.data);
          return Promise.resolve();
        } else {
          loginForm.password = ''  //输入框输入密码错误时 密码清空
          return Promise.reject(res.msg);
        }
        //
      } catch (err) {
        clearToken();
        throw err;
      }
    },
    async getUserRouters() {
      try {
        const res: any = await getRouters();
        if (res.code == 200) {
          return Promise.resolve(computedRouter(res.data));
        } else {
          return Promise.reject(res.msg);
        }
        //
      } catch (err) {
        throw err;
      }
    },
    // Logout
    async logout() {
      await userLogout();
      clearToken();
      removeRouteListener();
    },
  },
});

export default useUserStore;
